// @flow
import path from 'ramda/es/path';

import shopApiRequest from 'app/actions/shopApi';
import action from 'app/common/lib/action';
import { toCamelCase } from 'app/common/lib/object';


export const SHOP_UPDATECART_REQUEST = 'SHOP_UPDATECART_REQUEST';
export const SHOP_UPDATECART_SUCCESS = 'SHOP_UPDATECART_SUCCESS';
export const SHOP_UPDATECART_FAILURE = 'SHOP_UPDATECART_FAILURE';


/**
 * Обновление записи в корзине
 */
export const updateCartItem = (itemId: string, quantity: number) => async (dispatch: Function, getState: Function) => {
  const inData = { quantity };
  const cartId = getState().shop.cart.id;
  dispatch(action(SHOP_UPDATECART_REQUEST, { cartId, itemId, ...inData }));
  try {
    const res = await shopApiRequest(`carts/${cartId}/cart_items/${itemId}`, 'put', { data: inData });
    const data = toCamelCase(path(['data', 'data'], res));
    dispatch(action(SHOP_UPDATECART_SUCCESS, data));
    return true;
  } catch (error) {
    dispatch(action(SHOP_UPDATECART_FAILURE, {
      err: 'Изменение количества товара не удалось',
      data: { cartId, itemId, ...inData },
      error,
    }));
    return false;
  }
};
